import { render, staticRenderFns } from "./PersonalDataRepresentatives.vue?vue&type=template&id=5137fdfb&scoped=true&"
import script from "./PersonalDataRepresentatives.vue?vue&type=script&lang=js&"
export * from "./PersonalDataRepresentatives.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataRepresentatives.vue?vue&type=style&index=0&id=5137fdfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137fdfb",
  null
  
)

export default component.exports